const dotsConfig = {
    dotsUrl: ''
}
export default dotsConfig